const $ = jQuery.noConflict();

'use strict';
const Tabs = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domTabsBlockWrap: $('.js-single-product__upper-right-tabs'),
	$domTabsBlockBox: $('.js-single-product__upper-right-tabs-boxes'),
	$domTabsBlockBtn: $('.js-single-product__upper-right-tabs-btn'),
	classActive: 'is-active',

	/** @description Initialize */
	init: function() {
		this.tabsTabsBlock();
	},

	tabsTabsBlock: function() {
		Tabs.$domTabsBlockBtn.on('click', function(e) {
			e.preventDefault();
			$(this).siblings(Tabs.$domTabsBlockBtn).removeClass(Tabs.classActive);
			$(this).addClass(Tabs.classActive);
			const index = $(this).index();
			$(this).parent().parent().parent().find(Tabs.$domTabsBlockBox).hide();
			$(this).parent().parent().parent().children().find(Tabs.$domTabsBlockBox).eq(index).fadeIn('slow');
			if (window.innerWidth < 768) {
				$('html, body').animate({
					scrollTop: Tabs.$domTabsBlockWrap.offset().top -150
				}, 1000);
			}
		});
	},
};

export default Tabs;